module.exports = __webpack_public_path__ + "static/banner-part-4-79abf648af706ddee0f26e519b6a22e0.svg";